import { render, staticRenderFns } from "./IconHeart.vue?vue&type=template&id=8460048e&scoped=true&"
import script from "./IconHeart.vue?vue&type=script&lang=js&"
export * from "./IconHeart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8460048e",
  null
  
)

export default component.exports